import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared';
import { MaterialModule } from './shared/material.module';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { AppRoutingModule } from './app-routing.module';
import { ClientService, CoreModule } from './core';
import { AgmCoreModule } from '@agm/core';
import { ReceiptComponent } from './receipt/receipt.component';
import { AuthModule } from './auth/auth.module';
import { environment } from './../environments/environment';
import { ClientConstant } from './shared/constant';

const clientInitializer = (clientService: ClientService) => {
  return () => {
    return clientService.loadClients(ClientConstant.ClientSource.Database);
  };
};

@NgModule({
  declarations: [AppComponent, ReceiptComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    CoreModule,
    AuthModule,
    NgxUiLoaderModule,
    AgmCoreModule.forRoot({
      apiKey: environment.map_key,
      libraries: ['places', 'geometry', 'drawing', 'marker']
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: clientInitializer,
      multi: true,
      deps: [ClientService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
